import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { Observable } from 'rxjs';
import { ApiResponse } from '../Models/interfaces/responseData';
import { apiList, getApiUrl } from '../Constants/apiList';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  downloadTypes = {
    excel: 'application/vnd.ms-excel',
    text: 'text/plain'
  }

  constructor(
    private http: HttpClient
  ) { }
  objectToURLParam(obj: any): string {
    let param = '?';
    const excludedFileds = ['undefined', 'null', ''];
    for (const key in obj) {
      if (!excludedFileds.includes(encodeURIComponent(obj[key]))) {
        if (param !== '?') {
          param += '&';
        }
        param += key + '=' + encodeURIComponent(obj[key]);
      }
    }
    return param;
  }

  public saveToLocalStorage(key: string, value: any) {
    try {
      localStorage.setItem(key, value);
    } catch (err) {
      this.hasBlockerIssue();
    }
  }

  public getFromLocalStorage(key: string) {
    try {
      return localStorage.getItem(key);
    } catch (err) {
      this.hasBlockerIssue();
    }
    return null;
  }

  public hasBlockerIssue() {
    const hasIssues = (
      !navigator.cookieEnabled
    )
    if (hasIssues) {
      console.error({
        icon: 'error',
        title: 'Something went wrong!',
        text: 'Please try again after sometime.'
      })
    }
    return hasIssues;
  }

  public generalPaginationWithData(pageNumber: number, pageSize: number, data: any[] | undefined) {
    const startIndex = (pageNumber - 1) * pageSize;
    if (typeof pageSize === 'string') {
      pageSize = +pageSize;
    }
    if (data?.length && data.length > startIndex) {
      const endIndex = startIndex + pageSize;
      return data.slice(startIndex, endIndex);
    } else {
      return [];
    }
  }

  public download(response: any, type: string) : void {
    let fileName = 'file';
    const contentDisposition = response.headers.get('Content-Disposition');
    if (contentDisposition) {
      const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = fileNameRegex.exec(contentDisposition);
      if (matches != null && matches[1]) {
        fileName = matches[1].replace(/['"]/g, '');
      }
    }
    const fileContent = response.body;
    const blob = new Blob([fileContent], { type: type });
    const file = new File([blob], fileName, { type: type });
    FileSaver.saveAs(file);
  }

  public filterWithProperty(data: any[], propertyName: string, propertyValue: string) {
    if (!propertyValue) {
      return data
    }
    if (data && propertyName) {
      return data.filter(myObj => {
        return myObj[propertyName] && myObj[propertyName].toLowerCase().includes(propertyValue.toString().toLowerCase().trim())
      });
    }
    return []
  }

  public getCookie(cname: string): string {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let fullCookiesData = decodedCookie.split(';');
    for (let i = 0; i < fullCookiesData.length; i++) {
      let singleCookiesData = fullCookiesData[i];
      while (singleCookiesData.charAt(0) == ' ') {
        singleCookiesData = singleCookiesData.substring(1);
      }
      if (singleCookiesData.indexOf(name) == 0) {
        const fulldata = singleCookiesData.substring(name.length, singleCookiesData.length);
        const singleData = fulldata ? JSON.parse(window.atob(fulldata)) : '';
        return singleData;
      }
    }
    return '';
  }

  public setCookie(cname: string, cvalue: any) {
    document.cookie = cname + '=' + window.btoa(JSON.stringify(cvalue)) + '; path=/;';
  }

  public setSession(cname: string, cvalue: any) {
    sessionStorage.setItem(cname, cvalue);
  }

  public getSession(cname: string) {
    return sessionStorage.getItem(cname)
  }

  public filterGroupStting(FilterForm: FormGroup, data: any) {
    for (const key in data) {
      FilterForm?.controls[key]?.setValue(data[key])
    }
  }

  public lockView(page:string,id?: string): Observable<ApiResponse> {
    let endpoint = getApiUrl(`${apiList.lockScreen.lock}/${page}`);
    if(id){
      endpoint = `${endpoint}/${id}`
    }
    return this.http.patch<ApiResponse>(endpoint, '');
  }

  public unlockView(page: string,id:string): Observable<ApiResponse> {
    let endpoint = getApiUrl(`${apiList.lockScreen.unlocklock}/${page}`);
    if(id){
      endpoint = `${endpoint}/${id}`
    }
    return this.http.patch<ApiResponse>(endpoint, '');
  }

  public TekeOverView(page: string,id:string): Observable<ApiResponse> {
    let endpoint = getApiUrl(`${apiList.lockScreen.tackOver}/${page}`);
    if(id){
      endpoint = `${endpoint}/${id}`
    }
    return this.http.patch<ApiResponse>(endpoint, '');
  }


}
